module.exports = __webpack_public_path__ + "static/media/user-1.9864758e.png";